import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  clearTransporterData,
  createTransporter,
  fetchTransporterById,
  updateTransporter,
} from "../../../REDUX/actions/transporter";
import { isDefined } from "../../../Utils";
import TabsNavbar from "../../Common/TabsNavBar/TabsNavbar";
import LoaderWrapper from "../../../Utils/ViewWrapper/LoaderWrapper/LoaderWrapper";
import Button from "../../Common/FormElements/Button/Button";
import { closeRightModal } from "../../../REDUX/actions/rightModal";
import { infoElements } from "./data";
import TransporterForms from "./TransporterForms";

const TransporterModal = ({ id }) => {
  const TABS = ["Informations"];
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const { transporter, createLoading, updateLoading, transporterLoading } =
    useSelector((state) => state?.transporterReducer);

  const [activeTab, setActiveTab] = useState(TABS[0]);
  const [disabled, setDisabled] = useState(true);

  const [forms, setForms] = useState({
    infos: {
      user: {},
    },
  });

  const checkFormValidation = useCallback(() => {
    const updatedInvalidFields = [];
    infoElements?.forEach(({ name, required, showOnEdit }) => {
      if (required) {
        if (transporter?.id && showOnEdit === false) {
          return;
        }

        const value =
          name === "email" || name === "password"
            ? forms.infos.user[name]
            : forms.infos[name];
        if (
          value === undefined ||
          value === null ||
          !String(value)?.trim()?.length > 0
        ) {
          updatedInvalidFields.push(name);
        }
      }
    });
    if (updatedInvalidFields?.length > 0) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [forms, transporter?.id]);

  const handleClick = () => {
    const data = {
      name: forms.infos.name,
      phoneNumber: forms.infos.phoneNumber,
      companyName: forms.infos.companyName,
      companyPhoneNumber: forms.infos.companyPhoneNumber,
      companyEmail: forms.infos.companyEmail,
      user: {
        email: forms.infos.user.email,
        password: forms.infos.user.password,
        id: forms.infos.user.id, // For updates
      },
    };
    if (transporter?.id) {
      dispatch(
        updateTransporter(transporter?.id, data, t, () =>
          dispatch(closeRightModal())
        )
      );
    } else {
      dispatch(createTransporter(data, t, () => dispatch(closeRightModal())));
    }
  };

  useEffect(() => {
    checkFormValidation();
  }, [checkFormValidation]);

  useEffect(() => {
    if (isDefined(id)) {
      dispatch(fetchTransporterById(id));
    }
    return () => dispatch(clearTransporterData());
  }, [id, dispatch]);

  useEffect(() => {
    if (isDefined(transporter)) {
      setForms({
        infos: {
          id: transporter?.id,
          name: transporter?.attributes?.name,
          phoneNumber: transporter?.attributes?.phoneNumber,
          companyName: transporter?.attributes?.companyName,
          companyPhoneNumber: transporter?.attributes?.companyPhoneNumber,
          companyEmail: transporter?.attributes?.companyEmail,
          user: {
            id: transporter?.attributes?.user?.data?.id,
            email: transporter?.attributes?.user?.data?.attributes?.email,
          },
        },
      });
    }
  }, [transporter]);

  return (
    <div className="newRevendeur d-flex flex-column justify-content-between h100 min-w-1110px">
      <div className="flex-1 d-flex flex-column">
        <div className="alignH align-items-end">
          <h2 className={`sBold f25 quickSand text-blue ${"px-5"} mb-5`}>
            {id ? t("Modify the transporter") : t("Add a transporter")}
          </h2>
        </div>
        <TabsNavbar
          tabs={TABS}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          className={TABS?.length > 5 ? "gap-3" : "gap-5"}
        />
        <LoaderWrapper loading={transporterLoading}>
          <TransporterForms
            activeTab={activeTab}
            forms={forms}
            setForms={setForms}
          />
        </LoaderWrapper>

        <div className="buttonsContainer d-flex justify-content-center mt-auto">
          <Button
            variant="outline"
            className="me-4"
            onClick={() => dispatch(closeRightModal())}
          >
            {t("Cancel")}
          </Button>
          <Button
            loading={createLoading || updateLoading}
            disabled={disabled}
            onClick={createLoading || updateLoading ? undefined : handleClick}
          >
            {t("Save")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TransporterModal;
